
export enum PricingOption {
    SUGGESTED_RESERVE_PRICE = 'SUGGESTED_RESERVE_PRICE',
    TYPICALLY_SELLS_FOR = 'TYPICALLY_SELLS_FOR',
    FIXED_PLUS_CP = 'FIXED_PLUS_CP',
    PERCENTAGE = 'PERCENTAGE',
    FIXED = 'FIXED'
}